// extracted by mini-css-extract-plugin
module.exports = {"form":"form-963fc011"};